import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import { updateSinglePageLocalLogList } from 'redux/actions';
import { createSnapshotStatusMsg, errorCodeMsg, columns } from './utils';
import './LogsTable.css';

class LogsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sorted: []
    };

    this.reactTable = React.createRef();
    this.columns = columns(this);
    this.expandAll = true;
  }

  componentDidMount() {
    const { allHistoricalEventLogs, id, historicalEventLogs, selectedEventLogIndex } = this.props;
    let viewedDevices = allHistoricalEventLogs && Object.keys(allHistoricalEventLogs);

    if (viewedDevices && !viewedDevices.includes(id.toString())) {
      this.props.dispatch(updateSinglePageLocalLogList([]));
    } else {
      let events = [];

      if (
        historicalEventLogs &&
        historicalEventLogs[selectedEventLogIndex] &&
        historicalEventLogs[selectedEventLogIndex].events
      ) {
        events = historicalEventLogs[selectedEventLogIndex].events;
      }

      this.props.dispatch(updateSinglePageLocalLogList(events));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(updateSinglePageLocalLogList([]));
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedEventLogIndex, timestampOptions, localLogList } = this.props;
    if (prevProps.selectedEventLogIndex !== selectedEventLogIndex || prevProps.timestampOptions !== timestampOptions) {
      this.setState({ sorted: [] });
    }
    if (prevProps.localLogList !== localLogList) {
      this.columns = columns(this);
    }
  }

  getOverlay() {
    const ERROR_MESSAGE = `${
      errorCodeMsg[this.props.retrieveEventLogErrorCode]
    }. We are unable to complete your request. Please try it again later. If the problem persists, please contact `;
    const ERROR_TERMINAL_MESSAGE_1 =
      'We are sorry that it is taking longer than expected. We will keep working on it. Please check back on the status in a few minutes.';
    const ERROR_TERMINAL_MESSAGE_2 = 'If the problem persists, please email us at ';
    const error = this.props.historicalError || this.props.createSnapshotTimeoutMsg === createSnapshotStatusMsg.error;
    const isFetching =
      this.props.historicalFetching || this.props.createSnapshotTimeoutMsg === createSnapshotStatusMsg.pending;

    let overlay = null;
    if (error) {
      overlay = (
        <div className="logsTable_ErrorContainer">
          <div className="logsTable_ErrorInnerContainer">
            <div className="logsTable_ErrorTitle">Error: {this.props.retrieveEventLogErrorCode}</div>
            <div className="logsTable_ErrorMsg">
              {ERROR_MESSAGE}
              <a className="contactLink" href="mailto:support@pivotalcommware.com">
                Pivotal Commware customer support
              </a>
              <span>{'.'}</span>
            </div>
          </div>
        </div>
      );
    } else if (isFetching && this.props.createSnapshotTimeoutMsg === createSnapshotStatusMsg.tenSec) {
      overlay = (
        <div className="logsTable_loadingContainer">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
          </svg>
          <div className="logsTable_loadingMsg">Hang on... we are still working on it.</div>
        </div>
      );
    } else if (isFetching && this.props.createSnapshotTimeoutMsg === createSnapshotStatusMsg.thirtySec) {
      overlay = (
        <div className="logsTable_loadingContainer">
          <div className="logsTable_loadingContainer_30sec_InnerContainer">
            <div className="logsTable_ErrorMsg1">{ERROR_TERMINAL_MESSAGE_1}</div>
            <div className="logsTable_ErrorMsg2">
              {ERROR_TERMINAL_MESSAGE_2}
              <a className="contactLink" href="mailto:support@pivotalcommware.com">
                Pivotal Commware customer support
              </a>
              <span>{'.'}</span>
            </div>
          </div>
        </div>
      );
    } else if (isFetching) {
      overlay = (
        <div className="logsTable_loadingContainer">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
          </svg>
        </div>
      );
    } else if (this.props.localLogList && this.props.localLogList.length < 1) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">No snapshot available </div>
            {this.props.hasCmEventLogsPermission && (
              <div className="Global_Table_ErrorOverlay_Message">
                Click on the create snapshot button to create the first snapshot.
              </div>
            )}
          </div>
        </div>
      );
    }

    return overlay;
  }

  render() {
    const { localLogList } = this.props;

    const { sorted } = this.state;

    return (
      <ScrollReactTable
        pageSize={50}
        ref={this.reactTable}
        showPagination={true}
        showPageSizeOptions={false}
        showPageJump={false}
        resizable={true}
        sortable={true}
        minRows={10}
        overlay={this.getOverlay()}
        logsTable={true}
        className={'-highlight LogsTable Global_Table'}
        defaultPageSize={50}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (handleOriginal) {
                handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
              }
            }
          };
        }}
        getTrProps={(state, rowInfo, column) => {
          // const original = rowInfo && rowInfo.original
          // let messageLength = original && original.message ? original.message.length : 0;
          // let expandedRowHeight = messageLength > 75 ? Math.floor(messageLength/75) * 25 + 40 : 40;
          if (rowInfo) {
            /* This will assign the class 'selected-row' to a row when it has been clicked on. This class is used to apply css style to the selected row*/
            return {
              className: 'rowStyle',
              style: {
                height: '40px',
                transition: 'all .5s ease'
              }
            };
          } else {
            return {};
          }
        }}
        data={localLogList ? localLogList : []}
        columns={this.columns}
        sorted={sorted}
        onSortedChange={(newSorted, column, shiftKey) => {
          this.setState({ sorted: newSorted, dummy: true });
          //do nothing
        }}
        onPageChange={(pageNumber) => {
          this.expandAll = true;
          let trGroups = window.document.querySelectorAll('.rt-tr-group');
          trGroups.forEach((group) => {
            let trGroup = group.firstChild;
            let message = trGroup.querySelectorAll('.LogsTable_Message')[0];
            trGroup.style.height = '40px';
            trGroup.style.transition = 'all 0s ease';

            if (message) message.style.whiteSpace = 'nowrap';

            let svg = trGroup.getElementsByClassName('SvgAF') && trGroup.getElementsByClassName('SvgAF')[0];
            if (svg) {
              svg.getElementsByTagName('img')[0].style.transform = '';
            }
          });
          let tableBody = document.getElementsByClassName('scrollbar-container ps ps--active-y')[0];
          tableBody.scrollTop = 0;
        }}
      />
    );
  }
}

export default connect()(LogsTable);
